import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/Badge'
import { invoiceStatusLabel, invoiceStatusTone } from '../status'
import type { InvoiceStatus } from '../types'

export function InvoiceStatusBadge({ status, size = 'sm' }: { status: InvoiceStatus; size?: 'sm' | 'md' }) {
  const { t } = useTranslation('finance')
  return (
    <Badge tone={invoiceStatusTone[status]} dot size={size}>
      {t(invoiceStatusLabel[status])}
    </Badge>
  )
}
